module.exports = __webpack_public_path__ + "static/media/about.44825549.jpg";